export const types = {
  SET_RECIPES: "SET_RECIPES",
  SAVE_RECIPE: "SAVE_RECIPE",
  DELETE_RECIPE: "DELETE_RECIPE",
};
